<template>
<div class="max-content">
	<top :title="title" :color="color"></top>
	<div class="ppts">
        <div class="item" v-for="(value,key,index) in pptList" :key="index">
		    <img :src="value.banner"/>
            <span class="name">{{value.name}}</span>
            <van-button :url="value.bind_url" icon="down" color="#d2020d" size="small">下载</van-button>
        </div>
	</div>
</div>
</template>
<script>
	import {PPTs,ButtonDetail} from '../../../config/interface.js'
	import Top from "../components/Top";
	export default{
		components: {
    		Top
  		},
		data(){
			return{
                meeting_id:this.$route.query.meeting_id?this.$route.query.meeting_id:this.$route.query.MT_id,
				button_id:this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id,
				pptList:[],
				title:'',
				color:'#FFFFFF'
			}
		},
		mounted(){
            this.getPPTs();
			this.getButtonData();
		},
		methods:{
            getPPTs(){
                const url=PPTs;
				let params={
					meeting_id:this.meeting_id,
					button_id:this.button_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.pptList=res.data;

					}
				})
            },
            goTo(url){
				window.location.href=url;
			},
			//获取按钮信息
			getButtonData(){
				if(this.button_id){
					const url=ButtonDetail;
					let params={
                    	button_id:this.button_id
					}
					const method="POST";
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							document.title=res.data.share_title;
							this.title=res.data.name;
							if(res.data.top_color){
								this.color=res.data.top_color
							}else{
								this.color='#901D22'
							}
							if(common.is_weixin()){
								let data=res.data;
								common.wxShare(data.share_title,data.share_sub_title,data.share_img);
							}
						}
					})

				}
			}
			
		}
	}
</script>
<style lang="scss" scoped>
	.ppts{
        margin:15px;
        .item{
            margin-bottom:20px;
            img{
                width: 100%;
            }
            .name{
                font-size:18px;
                line-height: 36px;
            }
            .van-button{
                float:right;
            }

        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/PPTs.vue